import type { FormEvent } from 'react';
import { useState } from 'react';
import cookies from 'js-cookie';
import { httpClient } from '@alfa-bank/site-http-client';
import { FEEDBACK_FORM_HOST } from '@alfa-bank/site-envconfig';

import type { IFeedbackHook } from '../models';

export function useFeedbackLogic(props: IFeedbackHook) {
    const { codeTeam, onError, onSend, onSuccess, question, uri } = props;
    const [rateValue, onChangeRate] = useState<number | string | undefined>();
    const [commentValue, onChangeComment] = useState<string | undefined>();

    const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const data = {
            rate: rateValue,
            comment: commentValue?.trim(),
            platform: 'alfasite',
            codeTeam,
            uri: uri?.trim() || document.location.href,
            feedbackDate: new Date().toISOString(),
            question: question.questionText.trim(),
            cityPath: cookies.get('site_city'),
        };

        try {
            if (onSend) {
                onSend();
            }
            await httpClient.post(props.submitEndpoint || FEEDBACK_FORM_HOST(), {
                data,
            });
            if (onSuccess) {
                onSuccess();
            }
        } catch {
            if (onError) {
                onError();
            }
        } finally {
            onChangeRate(undefined);
            onChangeComment(undefined);
        }
    };

    return {
        rateValue,
        onChangeRate,
        commentValue,
        onChangeComment,
        onSubmit,
    };
}
